export const isShowSpinner = state => state.get('spinner');
